import { ListItem } from 'libs/end-to-end/src/types/generic/generic';
import { AIInterviewerDebugMode } from 'libs/end-to-end/src/types/ai-interviewer/ai-interviewer-debug-mode';
import { isValidYYYYMMDD } from 'libs/end-to-end/src/dates';

export const AI_INTERVIEWER_DEBUG_MODE_SELECT_ITEMS: ListItem<AIInterviewerDebugMode>[] =
  [
    {
      optionLabel: 'Disable Debug',
      optionValue: 'disable-debug',
    },
    {
      optionLabel: 'No ATS or Database Writes',
      optionValue: 'no-write',
    },
    {
      optionLabel: 'No ATS Writes',
      optionValue: 'no-write-ats',
    },
  ];

export const isValidAIInterviewerStartDate = (
  date: string | undefined,
): boolean => {
  if (!date) {
    return true;
  }

  return isValidYYYYMMDD(date);
};
